export enum AutosProducts {
    PLAN_KILOMETROS = "AEPlanKilometros",
    ROBO_TOTAL = "AERoboTotal",
    TODO_RIESGO_1 = "AETodoRiesgo1",
    TODO_RIESGO_RED_PREFERENTE = "AETodoRiesgoRedPreferente",
    TODO_RIESGO_SAGA_FALABELLA = "AETodoRiesgoSagaFalabella",
    TODO_RIESGO_2 = "AETodoRiesgo2",
    TODO_RIESGO_PANDERO = "AETodoRiesgoPandero",
    TODO_RIESGO_CONTACTO = "AETodoRiesgoContacto",
    TODO_RIESGO_MAR = "AETodoRiesgoMAR",
    TODO_RIESGO_MAF = "AETodoRiesgoMAF",
    TODO_RIESGO_GILDER = "AETodoRiesgoGILDER",
    AUTOENLATADO_MARSH_REHDER_PLAN96 = "AUTOEnlatadoMarshRehderPlan96",
    TODO_RIESGO_REGATAS = "AETodoRiesgoRegatas",
    TODO_RIESGO_MARIATEGUI = "AETodoRiesgoMariategui",
    TODO_RIESGO_WILLIS = "AETodoRiesgoWillis",
    TODO_RIESGO_MARSH_REDER = "AETodoRiesgoMarshRehder",
    AUTOENLATADO_TOTAL_LOSS = "AUTOEnlatadoTotalLoss",
    AUTOENLATADO_ROAD_ASSISTANCE = "AUTOEnlatadoRoadAssistance",
    AUTOENLATADO = "AUTOEnlatado",
    AUTOENLATADO_RC = "AUTOEnlatadoRC",
}

export enum HealthProducts {
    ONCO_COPAGO = "AD01",
    ONCO_COPAGO2 = "AD02",
    SALUD_PREFERENTE = "AM05",
    ONCO_INDENMIZATORIO = "AM12",
    ONCO_INTERNACIONAL = "CANC",
    ONCO_NACIONAL = "CANN",
    VIDA_INTERNACIONAL = "MINT",
    VIDA_NACIONAL = "MNAC",
    MULTISALUD = "MSLD",
    ONCOLOGICO = "VCAN",
    MEVI = "MEVI",
    MLTS = "MLTS",
    MPLN = "MPLN",
    AM10 = "AM10",
    AO01 = "AO01",
    AM06 = "AM06",
    AM11 = "AM11",
    GRAV = "GRAV",
    AM07 = "AM07",
    AM08 = "AM08",
    MULM = "MULM",
    AO03 = "AO03",
    VGRA = "VGRA",
    INDV = "INDV",
    FOLA = "FOLA",
    SECO = "SECO",
    CANB = "CANB",
    MLTP = "MLTP",
    AE08 = "AE08",
    AE09 = "AE09",
    AE06 = "AE06",
    AD03 = "AD03",
    AM13 = "AM13",
    AM14 = "AM14",
    AM15 = "AM15",
    AM17 = "AM17",
    AM18 = "AM18",
}

export enum SOATProducts {
    SOAT_TRADICIONAL = "TSOTradSOAT",
}

export enum EPSProducts {
    EPS_REGULAR = "R",
    EPS_INDIVIDUAL = "I",
}
